import { render, staticRenderFns } from "./CmgLoyaltyRewardCard.vue?vue&type=template&id=6a819d1e&scoped=true&lang=pug"
import script from "./cmg-loyalty-reward-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-reward-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyRewardCard.vue?vue&type=style&index=0&id=6a819d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a819d1e",
  null
  
)

export default component.exports